import React from "react";

export const DecorationTile: React.FC<{
  label: string;
  icon: React.ReactNode;
}> = ({ label, icon }) => (
  <div className="flex grow basis-0 flex-col items-center gap-2 rounded-lg bg-white/90 p-4">
    {icon}
    <span className="font-secondary text-sm leading-[21px] font-medium text-dark">
      {label}
    </span>
  </div>
);
